const theme = {
    colors: {
        primary: "aliceblue",
        secondary: '#141421',
        secondaryLight: 'rgb(41 41 49)',
        secondaryTransparent: 'rgb(20 20 33 / 70%)',
        third: '#C89446',
        dark: "rgba(11,11,11,0.85)",
        lightDark: "rgba(11,11,11,0.80)",
        validated: "#0fe50f",
        error: "#ff3b3b"
    },
    fonts: {
        primary: 'Raleway, sans-serif;',
        secondary: 'Pinyon Script, cursive;'
    }
};

export default theme
